const faqsData = [
  {
    title: '¿Cuándo hacerte una Prueba PCR?',
    bodies: [
      'Se recomienda la aplicación de la prueba PCR al momento de tener síntomas o 5-7 días después del posible contagio. Esta prueba se realiza mediante un raspado nasal y otro faríngeo y detecta la presencia del virus, lo que te indica una infección actual. '
    ]
  },
  {
    title: '¿Cuándo hacerte una Prueba rápida?',
    bodies: [
      'Se recomienda la aplicación de la prueba de anticuerpos mínimo 7 días después del posible contagio. Esta prueba se realiza en sangre y detecta la presencia de anticuerpos IgM o IgG contra el virus, lo que te indica una posible infección actual o pasada. '
    ]
  },
  // {
  //   title: '¿Cuándo hacerte una Prueba PCR?',
  //   bodies: [
  //     'Se recomienda la aplicación de la prueba de anticuerpos mínimo 7 días después del posible contagio. Esta prueba se realiza en sangre y detecta la presencia de anticuerpos IgM o IgG contra el virus, lo que te indica una posible infección actual o pasada.'
  //   ]
  // },
  {
    title: 'Síntomas',
    bodies: [
      `
      <b>Los síntomas más habituales son los siguientes:</b> <br />
      Fiebre <br />
      Tos seca <br />
      Cansancio <br />
      <b>Otros síntomas menos comunes son los siguientes:</b> <br />
      Molestias y dolores <br />
      Dolor de garganta <br />
      Diarrea <br />
      Conjuntivitis <br />
      Dolor de cabeza <br />
      Pérdida del sentido del olfato o del gusto <br />
      Erupciones cutáneas o pérdida del color en los dedos de las manos o de los pies   
      `
    ]
  },
  {
    title: 'Antecedentes de SARS-CoV-2',
    bodies: [
      `
      En enero de este año la OMS identificó un grupo de casos de neumonía grave en
      Wuhan China, cuyo agente etiológico era distinto a SARS-CoV y MERS-CoV. En
      febrero el Comité Internacional de Taxonomía de virus lo denomina SARS-CoV-2
      que es el causante del síndrome respiratorio agudo severo 2 o COVID-19
      asignándolo al grupo Betacoronavirus. <br />
      SARS-CoV-2 es un virus de ARN, que actualmente ha ocasionado gran impacto a
      nivel mundial por causar en el humano infecciones respiratorias graves con altos
      índices de contagio y mortalidad. La OMS en marzo reconoce como pandemia al
      COVID-19.<br /><br />
      Se transmite de persona a persona de manera directa por vía aérea al estar en
      contacto unos con otros a distancias menores de 1 metro. Las microgotas que son
      expulsadas al estornudar o hablar por personas infectadas es la fuente principal
      de transmisión del virus. También puede ser transmitida de manera indirecta a
      estar en contacto con superficies contaminadas con secreciones de personas
      infectadas.<br /><br />
      Las personas infectadas por SARS-CoV-2, pueden presentar una serie de signos
      y síntomas que podrían ser similares a la gripe común como: fiebre, cansancio,
      dolor de cabeza, dolor de garganta, perdida del olfato, congestión nasal, tos seca,
      entre otros, los cuales deben ser informadas a su médico de manera inmediata
      para realizar diagnóstico diferencial.<br /><br />
      No todas las personas cursan con los mismos síntomas y un porcentaje de los
      infectados son asintomáticos.<br /><br />
      Existen complicaciones severas a causa del virus que al no ser atendidas
      correctamente provocarían la muerte. 1 de cada 5 personas que contrae SARS-
      CoV-2 presenta un cuadro grave de la enfermedad (Según datos de la OMS).
      Los grupos más vulnerables de padecer las complicaciones de la enfermedad son
      adultos mayores y aquellos que tengan enfermedades como diabetes,
      hipertensión, trastornos inmunológicos, entre otros.<br /><br />
      En IML LABORATORIOS contamos con un área especializada en biología
      molecular, lo cual nos permite realizar estudios de RT-PCR para detección de
      SARS-CoV-2 (COVID 19).<br /><br />
      Trabajamos bajo los protocolos propuestos por la OMS y en cumplimiento con las
      regulaciones sanitarias de las entidades gubernamentales mexicanas. Contamos
      con los controles de calidad necesarios para asegurar el correcto proceso de
      todas nuestras muestras.<br /><br />
      Puedes contactarnos a través de estos canales:<br />
      <a class="hiperlink" href="https://api.whatsapp.com/send?phone=5214428173500&text=" target="_blank">
        Whatsapp
      </a><br />
      <a class="hiperlink" href="https://iml.vercel.app/" >
        Tienda en Línea
      </a><br />
      
      <a class="hiperlink" href="phone:4422130898">Teléfono: 442 213 0898</a><br />
      `
    ]
  },
  {
    title: '¿Qué es un coronavirus?',
    bodies: [
      'Los coronavirus son una extensa familia de virus que pueden causar enfermedades tanto en animales como en humanos. En los humanos, se sabe que varios coronavirus causan infecciones respiratorias que pueden ir desde el resfriado común hasta enfermedades más graves como el síndrome respiratorio de Oriente Medio (MERS) y el síndrome respiratorio agudo severo (SRAS). El coronavirus que se ha descubierto más recientemente causa la enfermedad por coronavirus COVID-19.'
    ]
  },
  {
    title: '¿Qué es la COVID-19?',
    bodies: [
      'La COVID-19 es la enfermedad infecciosa causada por el coronavirus que se ha descubierto más recientemente. Tanto este nuevo virus como la enfermedad que provoca eran desconocidos antes de que estallara el brote en Wuhan (China) en diciembre de 2019. Actualmente la COVID-19 es una pandemia que afecta a muchos países de todo el mundo.'
    ]
  },
  {
    title: '¿Cuáles son los síntomas de la COVID-19?',
    bodies: [
      `
      Los síntomas más habituales de la COVID-19 son la fiebre, la tos seca y el cansancio. Otros síntomas menos frecuentes que afectan a algunos pacientes son los dolores y molestias, la congestión nasal, el dolor de cabeza, la conjuntivitis, el dolor de garganta, la diarrea, la pérdida del gusto o el olfato y las erupciones cutáneas o cambios de color en los dedos de las manos o los pies. Estos síntomas suelen ser leves y comienzan gradualmente. Algunas de las personas infectadas solo presentan síntomas levísimos. <br />
      La mayoría de las personas (alrededor del 80%) se recuperan de la enfermedad sin necesidad de tratamiento hospitalario. Alrededor de 1 de cada 5 personas que contraen la COVID-19 acaba presentando un cuadro grave y experimenta dificultades para respirar. Las personas mayores y las que padecen afecciones médicas previas como hipertensión arterial, problemas cardiacos o pulmonares, diabetes o cáncer tienen más probabilidades de presentar cuadros graves. Sin embargo, cualquier persona puede contraer la COVID-19 y caer gravemente enferma. Las personas de cualquier edad que tengan fiebre o tos y además respiren con dificultad, sientan dolor u opresión en el pecho o tengan dificultades para hablar o moverse deben solicitar atención médica inmediatamente. Si es posible, se recomienda llamar primero al profesional sanitario o centro médico para que estos remitan al paciente al establecimiento sanitario adecuado.      
      `
    ]
  },
  {
    title: '¿Qué debo hacer si tengo síntomas de COVID-19 y cuándo he de buscar atención médica?',
    bodies: [
      `
      Si tiene síntomas leves, como tos o fiebre leves, generalmente no es necesario que busque atención médica. Quédese en casa, aíslese y vigile sus síntomas. Siga las orientaciones nacionales sobre el autoaislamiento. Sin embargo, si vive en una zona con paludismo (malaria) o dengue, es importante que no ignore la fiebre. Busque ayuda médica. Cuando acuda al centro de salud lleve mascarilla si es posible, manténgase al menos a un metro de distancia de las demás personas y no toque las superficies con las manos. En caso de que el enfermo sea un niño, ayúdelo a seguir este consejo. <br />
      Busque inmediatamente atención médica si tiene dificultad para respirar o siente dolor o presión en el pecho. Si es posible, llame a su dispensador de atención de la salud con antelación para que pueda dirigirlo hacia el centro de salud adecuado.      
      `
    ]
  },
  {
    title: '¿Cómo se propaga la COVID-19?',
    bodies: [
      `
      Una persona puede contraer la COVID-19 por contacto con otra que esté infectada por el virus. La enfermedad se propaga principalmente de persona a persona a través de las gotículas que salen despedidas de la nariz o la boca de una persona infectada al toser, estornudar o hablar. Estas gotículas son relativamente pesadas, no llegan muy lejos y caen rápidamente al suelo. Una persona puede contraer la COVID-19 si inhala las gotículas procedentes de una persona infectada por el virus. Por eso es importante mantenerse al menos a un metro de distancia de los demás. Estas gotículas pueden caer sobre los objetos y superficies que rodean a la persona, como mesas, pomos y barandillas, de modo que otras personas pueden infectarse si tocan esos objetos o superficies y luego se tocan los ojos, la nariz o la boca. Por ello es importante lavarse las manos frecuentemente con agua y jabón o con un desinfectante a base de alcohol. <br />
      La OMS está estudiando las investigaciones en curso sobre las formas de propagación de la COVID-19 y seguirá informando sobre las conclusiones que se vayan obteniendo.
      `
    ]
  },
  {
    title: '¿Es posible contagiarse de COVID-19 por contacto con una persona que no presente ningún síntoma?',
    bodies: [
      `
      La principal forma de propagación de la COVID-19 es a través de las gotículas respiratorias expelidas por alguien que tose o que tiene otros síntomas como fiebre o cansancio. Muchas personas con COVID-19 presentan solo síntomas leves. Esto es particularmente cierto en las primeras etapas de la enfermedad. Es posible contagiarse de alguien que solamente tenga una tos leve y no se sienta enfermo. <br />
      Según algunas informaciones, las personas sin síntomas pueden transmitir el virus. Aún no se sabe con qué frecuencia ocurre. La OMS está estudiando las investigaciones en curso sobre esta cuestión y seguirá informando sobre las conclusiones que se vayan obteniendo.
      
      `
    ]
  },
  {
    title: '¿Cómo podemos protegernos a nosotros mismos y a los demás si no sabemos quién está infectado?',
    bodies: [
      `
      Practicar la higiene respiratoria y de las manos es importante en TODO momento y la mejor forma de protegerse a sí mismo y a los demás. <br />
      Cuando sea posible, mantenga al menos un metro de distancia entre usted y los demás. Esto es especialmente importante si está al lado de alguien que esté tosiendo o estornudando. Dado que es posible que algunas personas infectadas aún no presenten síntomas o que sus síntomas sean leves, conviene que mantenga una distancia física con todas las personas si se encuentra en una zona donde circule el virus de la COVID-19.
      `
    ]
  },
  {
    title: '¿Qué debo hacer si he estado en contacto estrecho con alguien que tiene COVID-19?',
    bodies: [
      `
      Si ha estado en contacto estrecho con alguien con COVID-19, puede estar infectado. <br />
      Contacto estrecho significa vivir con alguien que tiene la enfermedad o haber estado a menos de un metro de distancia de alguien que tiene la enfermedad. En estos casos, es mejor quedarse en casa.<br />
      Sin embargo, si usted vive en una zona con paludismo (malaria) o dengue, es importante que no ignore la fiebre. Busque ayuda médica. Cuando acuda al centro de salud lleve mascarilla si es posible, manténgase al menos a un metro de distancia de las demás personas y no toque las superficies con las manos. En caso de que el enfermo sea un niño, ayúdelo a seguir este consejo. <br />
      Si no vive en una zona con paludismo (malaria) o dengue, por favor haga lo siguiente:<br />
      <ul>
      <li>
        Si enferma, incluso con síntomas muy leves como fiebre y dolores leves, debe aislarse en su casa. 
      </li>
      <li>
        Incluso si no cree haber estado expuesto a la COVID-19 pero desarrolla estos síntomas, aíslese y controle su estado.
      </li>
      <li>
        Es más probable que infecte a otros en las primeras etapas de la enfermedad cuando solo tiene síntomas leves, por lo que el aislamiento temprano es muy importante.
      </li>
      <li>
      Si no tiene síntomas pero ha estado expuesto a una persona infectada, póngase en cuarentena durante 14 días.
      </li>
      </ul>
      Si ha tenido indudablemente COVID-19 (confirmada mediante una prueba), aíslese durante 14 días incluso después de que los síntomas hayan desaparecido como medida de precaución. Todavía no se sabe exactamente cuánto tiempo las personas siguen siendo contagiosas después de recuperarse. Siga los consejos de las autoridades nacionales sobre el aislamiento.
      `
    ]
  },
  {
    title: '¿Qué significa aislarse?',
    bodies: [
      `
        El aislamiento es una medida importante que adoptan las personas con síntomas de COVID-19 para evitar infectar a otras personas de la comunidad, incluidos sus familiares. <br />
        El aislamiento se produce cuando una persona que tiene fiebre, tos u otros síntomas de COVID-19 se queda en casa y no va al trabajo, a la escuela o a lugares públicos. Lo puede hacer voluntariamente o por recomendación de su dispensador de atención de salud. Sin embargo, si vive en una zona con paludismo (malaria) o dengue, es importante que no ignore la fiebre. Busque ayuda médica. Cuando acuda al centro de salud use una mascarilla si es posible, manténgase al menos a un metro de distancia de las demás personas y no toque las superficies con las manos. En caso de que el enfermo sea un niño, ayúdelo a seguir este consejo. <br />
        Si no vive en una zona con paludismo (malaria) o dengue, por favor haga lo siguiente: <br />
        Si una persona se encuentra en aislamiento, es porque está enferma pero no gravemente enferma (en cuyo caso requeriría atención médica) <br />
        <ul>
          <li>
          Ocupe una habitación individual amplia y bien ventilada con retrete y lavabo.
          </li>
          <li>
          Si esto no es posible, coloque las camas al menos a un metro de distancia.
          </li>
          <li>
          Manténgase al menos a un metro de distancia de los demás, incluso de los miembros de su familia.
          </li>
          <li>
          Controle sus síntomas diariamente.
          </li>
          <li>
          Aíslese durante 14 días, incluso si se siente bien.
          </li>
          <li>
          Si tiene dificultades para respirar, póngase en contacto inmediatamente con su dispensador de atención de salud. Llame por teléfono primero si es posible. 
          </li>
          <li>
          Permanezca positivo y con energía manteniendo el contacto con sus seres queridos por teléfono o internet y haciendo ejercicio en casa.
          </li>
        </ul>
      
      `
    ]
  },
  {
    title: '¿Qué debo hacer si no tengo síntomas pero creo que he estado expuesto a la COVID-19? ¿qué significa ponerse en cuarentena?',
    bodies: [
      `
      Ponerse en cuarentena significa separarse de los demás porque ha estado expuesto a alguien con COVID-19 aunque usted mismo no tenga síntomas. Durante la cuarentena, debe vigilar su estado para detectar síntomas. El objetivo de la cuarentena es prevenir la transmisión. Dado que las personas que enferman de COVID-19 pueden infectar a otros inmediatamente, la cuarentena puede evitar que se produzcan algunas infecciones. <br />
      En este caso: <br />
      <ul>
        <li>
        Ocupe una habitación individual amplia y bien ventilada con retrete y lavabo.
        </li>
        <li>
        Si esto no es posible, coloque las camas al menos a un metro de distancia.
        </li>
        <li>
        Manténgase al menos a un metro de distancia de los demás, incluso de los miembros de su familia.
        </li>
        <li>
        Controle sus síntomas diariamente.
        </li>
        <li>
        Permanezca en cuarentena durante 14 días, incluso si se siente bien.
        </li>
        <li>
        Si tiene dificultades para respirar, póngase en contacto inmediatamente con su dispensador de atención de salud. Llame por teléfono primero si es posible.
        </li>
        <li>
        Permanezca positivo y con energía manteniendo el contacto con sus seres queridos por teléfono o internet y haciendo ejercicio en casa.
        </li>
      </ul>
      Sin embargo, si vive en una zona con paludismo (malaria) o dengue, es importante que no ignore la fiebre. Busque ayuda médica. Cuando acuda al centro de salud use una mascarilla si es posible, manténgase al menos a un metro de distancia de las demás personas y no toque las superficies con las manos. En caso de que el enfermo sea un niño, ayúdelo a seguir este consejo.
      `
    ]
  },
  {
    title: '¿Cuál es la diferencia entre aislamiento, cuarentena y distanciamiento?',
    bodies: [
      `
      La cuarentena significa restringir las actividades o separar a las personas que no están enfermas pero que pueden haber estado expuestas a la COVID-19. El objetivo es prevenir la propagación de la enfermedad en el momento en que las personas empiezan a presentar síntomas. <br />
      El aislamiento significa separar a las personas que están enfermas con síntomas de COVID-19 y pueden ser contagiosas para prevenir la propagación de la enfermedad.<br />
      El distanciamiento físico significa estar físicamente separado. La OMS recomienda mantener una distancia de al menos un metro con los demás. Es una medida general que todas las personas deberían adoptar incluso si se encuentran bien y no han tenido una exposición conocida a la COVID-19.<br />
      `
    ]
  },
  {
    title: '¿Pueden los niños o los adolescentes contraer la COVID-19?',
    bodies: [
      `
      Las investigaciones indican que los niños y los adolescentes tienen las mismas probabilidades de infectarse que cualquier otro grupo de edad y pueden propagar la enfermedad. <br />
      Las pruebas hasta la fecha sugieren que los niños y los adultos jóvenes tienen menos probabilidades de desarrollar una enfermedad grave, pero con todo se pueden dar casos graves en estos grupos de edad. <br />
      Los niños y los adultos deben seguir las mismas pautas de cuarentena y aislamiento si existe el riesgo de que hayan estado expuestos o si presentan síntomas. Es particularmente importante que los niños eviten el contacto con personas mayores y con otras personas que corran el riesgo de contraer una enfermedad más grave.<br />
      
      `
    ]
  },
  {
    title: '¿Qué puedo hacer para protegerme y prevenir la propagación de la enfermedad?',
    bodies: [
      `
      Manténgase al día de la información más reciente sobre el brote de COVID-19, a la que puede acceder en el sitio web de la OMS y a través de las autoridades de salud pública a nivel nacional y local. Se han registrado casos en la mayoría de los países del mundo, y en muchos de ellos se han producido brotes. Las autoridades de algunos países han conseguido ralentizar el avance de los brotes, pero la situación es impredecible y es necesario comprobar con regularidad las noticias más recientes. <br />
      Hay varias precauciones que se pueden adoptar para reducir la probabilidad de contraer o propagar la COVID-19: <br />
      <ul style="margin: 1em 1em .5em 0em">
        <li>Lávese las manos a fondo y con frecuencia usando un desinfectante a base de alcohol o con agua y jabón.</li>
      </ul>
      <span>¿Por qué?</span>
        Lavarse las manos con agua y jabón o con un desinfectante a base de alcohol mata los virus que pueda haber en sus manos. <br />
  
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Mantenga una distancia mínima de un metro entre usted y los demás.
        </li>
      </ul>
      
      <span>¿Por qué?</span>Cuando alguien tose, estornuda o habla despide por la nariz o la boca unas gotículas de líquido que pueden contener el virus. Si la persona que tose, estornuda o habla tiene la enfermedad y usted está demasiado cerca de ella, puede respirar las gotículas y con ellas el virus de la COVID-19.<br />
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Evite ir a lugares concurridos
        </li>
      </ul>

      <span>¿Por qué?</span>Cuando hay aglomeraciones, hay más probabilidades de que entre en contacto estrecho con alguien que tenga COVID-19 y es más difícil mantener una distancia física de un metro.

      <ul style="margin: 1em 1em .5em 0em">
        <li>
          Evite tocarse los ojos, la nariz y la boca
        </li>
      </ul>

      <span>¿Por qué?</span>Las manos tocan muchas superficies y pueden recoger virus. Una vez contaminadas, las manos pueden transferir el virus a los ojos, la nariz o la boca. Desde allí, el virus puede entrar en su cuerpo y causarle la enfermedad.
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Tanto usted como las personas que lo rodean deben asegurarse de mantener una buena higiene respiratoria. Eso significa cubrirse la boca y la nariz con el codo flexionado o con un pañuelo al toser o estornudar. Deseche de inmediato el pañuelo usado y lávese las manos.
        </li>
      </ul>

      <span>¿Por qué?</span>Los virus se propagan a través de las gotículas. Al mantener una buena higiene respiratoria protege a las personas que lo rodean de virus como los del resfriado, la gripe y la COVID-19.
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Permanezca en casa y aíslese incluso si presenta síntomas leves como tos, dolor de cabeza y fiebre ligera hasta que se recupere. Pida a alguien que le traiga las provisiones. Si tiene que salir de casa, póngase una mascarilla para no infectar a otras personas.
        </li>
      </ul>

      <span>¿Por qué?</span>Evitar el contacto con otras personas las protegerá de posibles infecciones por el virus de la COVID-19 u otros.</br>
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Si tiene fiebre, tos y dificultad para respirar, busque atención médica, pero en la medida de lo posible llame por teléfono con antelación y siga las indicaciones de la autoridad sanitaria local.
        </li>
      </ul>

      <span>¿Por qué?</span>Las autoridades nacionales y locales dispondrán de la información más actualizada sobre la situación en su zona. Llamar con antelación permitirá que su dispensador de atención de salud le dirija rápidamente hacia el centro de salud adecuado. Esto también lo protegerá a usted y ayudará a prevenir la propagación de virus y otras infecciones.<br />
      <ul style="margin: 1em 1em .5em 0em">
        <li>
        Manténgase informado sobre las últimas novedades a partir de fuentes fiables, como la OMS o las autoridades sanitarias locales y nacionales.
        </li>
      </ul>

      <span>¿Por qué?</span>Las autoridades locales y nacionales son los interlocutores más indicados para dar consejos sobre lo que deben hacer las personas de su zona para protegerse.<br />
      `
    ]
  },
  {
    title: '¿Existe alguna vacuna, medicamento o tratamiento contra la COVID-19?',
    bodies: [
      `
      Aunque algunas soluciones de la medicina occidental o tradicional o remedios caseros pueden resultar reconfortantes y aliviar los síntomas leves de la COVID-19, hasta ahora ningún medicamento ha demostrado prevenir o curar esta enfermedad. La OMS no recomienda automedicarse con ningún fármaco, incluidos los antibióticos, para prevenir o curar la COVID-19. Sin embargo, hay varios ensayos clínicos en marcha, tanto de medicamentos occidentales como tradicionales. La OMS está coordinando la labor de desarrollo de vacunas y medicamentos para prevenir y tratar la COVID-19 y seguirá proporcionando información actualizada a medida que se disponga de los resultados de las investigaciones. <br />
      Las formas más eficaces de protegerse a uno mismo y a los demás frente a la COVID-19 son: <br />
        <ul>
          <li>
          Lavarse las manos a fondo y con frecuencia.
          </li>
          <li>
          Evitar tocarse los ojos, la boca y la nariz.
          </li>
          <li>
          Cubrirse la boca con el codo flexionado o con un pañuelo. Si se utiliza un pañuelo, hay que desecharlo inmediatamente después de su uso y lavarse las manos.
          </li>
          <li>
          Mantener una distancia de al menos un metro con las demás personas.
          </li>
        </ul>
      `
    ]
  },
  {
    title: '¿Recomienda la OMS el uso de mascarillas médicas para prevenir la propagación de la COVID-19?',
    bodies: [
      `
      Actualmente no hay suficientes pruebas a favor o en contra del uso de mascarillas (médicas o de otro tipo) por personas sanas de la comunidad en general. Sin embargo, la OMS está estudiando activamente los datos científicos acerca del uso de mascarillas, los cuales evolucionan rápidamente, y actualiza continuamente sus orientaciones al respecto. <br />
      El uso de mascarillas médicas está recomendado principalmente en entornos sanitarios, pero puede considerarse en otras circunstancias (véase más adelante). <br />
      Las mascarillas médicas deben combinarse con otras medidas clave de prevención y control de las infecciones, como la higiene de las manos y el distanciamiento físico.  <br /><br />
      
      <span>Trabajadores sanitarios</span> <br />
      <span>¿Por qué?</span>
      Las mascarillas médicas y respiradores del tipo N95, FFP2 o equivalentes se recomiendan y deben reservarse para los trabajadores sanitarios que están atendiendo a pacientes. El contacto cercano con personas con infección probable o confirmada por el virus de la COVID-19 y su entorno es la principal vía de transmisión, lo que significa que los trabajadores sanitarios son los más expuestos.<br /><br />
      
      <span>Las personas enfermas y que presentan síntomas de COVID-19</span> <br />
      <span>¿Por qué?</span>
      Cualquier persona que esté enferma y presente síntomas leves, como dolores musculares, tos leve, dolor de garganta o cansancio, debe aislarse en su casa y usar una mascarilla médica de conformidad con la recomendación de la OMS sobre el cuidado en el hogar de los pacientes con posible infección por el virus de la COVID-19. Al toser, estornudar o hablar se pueden generar gotículas que causan la propagación de la infección. Estas gotículas pueden llegar a la cara de otras personas cercanas y caer en el entorno circundante. El hecho de que una persona infectada que tose, estornuda o habla lleve una mascarilla médica puede ayudar a proteger de la infección a quienes están cerca.<br />
      Si una persona enferma necesita ir a un centro de salud, debe llevar una máscara médica.<br /><br />
      
      <span>Toda persona que cuide en casa a un enfermo de COVID-19</span> <br />
      <span>¿Por qué?</span>
      Quienes cuidan de enfermos de COVID-19 deben usar una mascarilla médica para protegerse. Una vez más, el contacto cercano, frecuente y prolongado con alguien con COVID-19 pone a los cuidadores en una situación de alto riesgo. <br />
      Los responsables de la toma de decisiones a nivel nacional también pueden optar por recomendar el uso de mascarillas médicas por ciertas personas adoptando un enfoque basado en los riesgos. Este enfoque toma en consideración el propósito de la mascarilla, el riesgo de exposición y la vulnerabilidad del portador de la mascarilla, el entorno, la viabilidad de su uso y los tipos de mascarillas.<br />

      `
    ]
  },
  {
    title: 'Cómo utilizar adecuadamente una mascarilla médica',
    bodies: [
      `
      Si opta por llevar una mascarilla, tenga en cuenta lo siguiente:<br>
      <ol>
        <li>
        Antes de tocar la mascarilla, lávese las manos con un desinfectante a base de alcohol o con agua y jabón
        </li>
        <li>
        Inspeccione la mascarilla para ver si tiene rasgaduras o agujeros
        </li>
        <li>
        Oriente hacia arriba la parte superior (donde se encuentra la tira de metal)
        </li>
        <li>
        Asegúrese de orientar hacia afuera el lado correcto de la mascarilla (el lado con color)
        </li>
        <li>
        Colóquese la mascarilla sobre la cara. Pellizque la tira de metal o el borde rígido de la mascarilla para que se amolde a la forma de su nariz
        </li>
        <li>
        Tire hacia abajo de la parte inferior de la mascarilla para que le cubra la boca y la barbilla
        </li>
        <li>
        No toque la mascarilla mientras la lleve a efectos de protección
        </li>
        <li>
        No toque la mascarilla mientras la lleve a efectos de protección
        </li>
        <li>
        Después de usar la mascarilla, quítesela con las manos limpias; retire las cintas elásticas de detrás de las orejas manteniendo la mascarilla alejada de la cara y la ropa, para no tocar las superficies potencialmente contaminadas de la mascarilla.
        </li>
        <li>
        Deseche la mascarilla en un contenedor cerrado inmediatamente después de su uso. No reutilice la mascarilla.
        </li>
        <li>
        Practique la higiene de las manos después de tocar o desechar la mascarilla. Use un desinfectante a base de alcohol o, si están visiblemente sucias, láveselas con agua y jabón.
        </li>
      </ol>
      Tenga en cuenta que hay una escasez mundial de mascarillas médicas (tanto de mascarillas quirúrgicas como de mascarillas N95), por lo que estas deberían reservarse en la medida de lo posible para los trabajadores sanitarios. <br />
      Recuerde que las mascarillas no sustituyen otras formas más eficaces de protegerse a sí mismo y a los demás contra la COVID-19, como lavarse las manos con frecuencia, cubrirse la boca con el codo flexionado o con un pañuelo y mantener una distancia de al menos un metro con los demás. Consulte las medidas de protección básicas contra el nuevo coronavirus para obtener más información.<br />
      Siga los consejos de la autoridad sanitaria nacional sobre el uso de mascarillas. <br />
      `
    ]
  },
  {
    title: '¿Cuánto tiempo transcurre entre la exposición a la COVID-19 y el desarrollo de síntomas?',
    bodies: [
      `
      El tiempo que transcurre entre la exposición a la COVID-19 y el momento en que comienzan los síntomas suele ser de alrededor de cinco o seis días, pero puede variar entre 1 y 14 días.
      `
    ]
  },
  {
    title: '¿Qué relación hay entre la COVID-19 y los animales?',
    bodies: [
      `
      La COVID-19 se propaga por transmisión entre seres humanos. <br />
      Conocemos bastantes datos sobre otros virus de la familia de los coronavirus, y la mayoría de estos tipos de virus tienen su origen en animales. El virus de la COVID-19 (también llamado SARS-CoV-2) es un nuevo virus en los humanos. La posible fuente animal de la COVID-19 aún no ha sido confirmada, pero se está investigando.<br />
      La OMS sigue monitoreando las últimas investigaciones sobre este y otros temas relacionados con la COVID-19 y proporcionará información actualizada a medida que se disponga de nuevos datos.<br />
      
      `
    ]
  },
  {
    title: '¿Puede un animal doméstico u otro animal contagiarme la COVID-19?',
    bodies: [
      `
      Varios perros y felinos (gatos domésticos y tigres) han dado positivo en las pruebas de detección de la COVID-19 después de haber estado en contacto con humanos infectados. Además, parece ser que los hurones son susceptibles a la infección. En condiciones experimentales, tanto los gatos como los hurones pueden transmitir la infección a otros animales de la misma especie. Sin embargo, no existen datos probatorios de que estos animales puedan transmitir la enfermedad al ser humano y propagar la COVID-19. La COVID-19 se propaga principalmente a través de las gotículas que despide una persona infectada al toser, estornudar o hablar. <br />
      También se ha detectado el virus en visones criados en granjas que probablemente habían sido infectados por trabajadores. En algunos casos, los visones infectados por seres humanos han transmitido el virus a otras personas. Son los primeros casos notificados de transmisión del animal al ser humano. <br />
      Se sigue recomendando que las personas enfermas de COVID-19 y las personas de riesgo limiten el contacto con animales de compañía y otros animales. En el manejo y cuidado de los animales, siempre se deben tomar medidas básicas de higiene, a saber: lavarse las manos después de manipular animales, su comida o sus artículos, así como evitar besarlos, dejar que nos laman o compartir comida.<br />
      El sitio web de la OIE proporciona más recomendaciones al respecto: <a style="color: var(--first);
      text-decoration: underline;" target="_blank" href="https://www.oie.int/es/nuestra-experiencia-cientifica/informaciones-especificas-y-recomendaciones/preguntas-y-respuestas-del-nuevo-coronavirus-2019/">https://www.oie.int/es/nuestra-experiencia-cientifica/informaciones-especificas-y-recomendaciones/preguntas-y-respuestas-del-nuevo-coronavirus-2019/</a><br />
      La OMS seguirá haciendo un seguimiento de los últimos estudios sobre este tema y otros temas relacionado con la COVID-19 y actualizará la información a medida que disponga de nuevas conclusiones.<br />
      `
    ]
  },
  {
    title: '¿Cuánto tiempo sobrevive el virus en las superficies?',
    bodies: [
      `
      Lo más importante que hay que saber sobre el contacto del coronavirus con superficies es que estas se pueden limpiar fácilmente con desinfectantes domésticos comunes que matarán el virus. Diversos estudios han demostrado que el virus de la COVID-19 puede sobrevivir hasta 72 horas en superficies de plástico y acero inoxidable, menos de 4 horas en superficies de cobre y menos de 24 horas en superficies de cartón. <br />
      Como siempre, lávese las manos con un desinfectante a base de alcohol o con agua y jabón. Evite tocarse los ojos, la boca o la nariz. <br />     
      `
    ]
  },
  {
    title: '¿Cómo puedo comprar con seguridad en las tiendas de comestibles?',
    bodies: [
      `
      En las tiendas de comestibles, mantenga al menos un metro de distancia con los demás y no se toque los ojos, la nariz o la boca. Si es posible, desinfecte los mangos y barras de los carritos o cestas antes de comprar. Cuando regrese a casa, lávese las manos a fondo al llegar y también después de coger y almacenar los productos que ha comprado. Actualmente no hay ningún caso confirmado de contagio de la COVID-19 a través de los alimentos o de sus envases.
      `
    ]
  },
  {
    title: '¿Cómo debo lavar las frutas y las hortalizas?',
    bodies: [
      `
      Las frutas y las hortalizas son esenciales para llevar una dieta saludable. Lávelas como lo haría en cualquier circunstancia. Antes de tocarlas, lávese las manos con agua y jabón. Después, lave las frutas y las hortalizas a fondo con agua potable, sobre todo si las come crudas.
      `
    ]
  },
  {
    title: '¿Son eficaces los antibióticos para prevenir o tratar la COVID-19?',
    bodies: [
      `
      No. Los antibióticos no son eficaces contra los virus, solo contra las infecciones bacterianas. La COVID-19 está causada por un virus, de modo que los antibióticos no sirven frente a ella. No se deben usar antibióticos como medio de prevención o tratamiento de la COVID-19. En los hospitales, los médicos a veces utilizan antibióticos para prevenir o tratar infecciones bacterianas secundarias que pueden ser una complicación de la COVID-19 en pacientes gravemente enfermos. Solo deben usarse para tratar una infección bacteriana siguiendo las indicaciones de un médico.
      `
    ]
  },
  {
    title: '¿Puedo contagiarme de COVID-19 por contacto con las heces de una persona que padezca la enfermedad?',
    bodies: [
      `
      Aunque las investigaciones iniciales apuntan a que el virus puede estar presente en algunos casos en las heces, hasta la fecha no se ha notificado ningún caso de transmisión por vía fecal-oral del virus de la COVID-19. Además, hasta la fecha no hay pruebas de que el virus de la COVID-19 sobreviva en el agua, incluidas las aguas residuales. <br />
      La OMS está estudiando las investigaciones en curso sobre las formas de propagación de la COVID-19 y seguirá informando de las novedades acerca de esta cuestión. 

      `
    ]
  },
  {
    title: 'Enlaces con información',
    bodies: [
      `
      Sitio web sobre la COVID-19: <a target="_blank" style="color: var(--initial); text-decoration: underline" href="https://www.who.int/es/emergencies/diseases/novel-coronavirus-2019">https://www.who.int/es/emergencies/diseases/novel-coronavirus-2019</a> <br />
      EPI-WIN: Red de Información de la OMS sobre Epidemias: <a  style="color: var(--initial); text-decoration: underline" href="https://www.who.int/epi-win" target="_blank" >https://www.who.int/epi-win</a><br />
      Gobierno del estado <a style="color: var(--initial); text-decoration: underline" href="https://www.queretaro.gob.mx/covid19/" target="_balnk">https://www.queretaro.gob.mx/covid19/</a>
      `
    ]
  }
]

export default faqsData
